import React from 'react';
import {makeStyles} from '@material-ui/core/styles';
import SizedImage from 'components/SizedImage';
import Conf from '../../utils/Conf';

/* 16:9, for an aspect ratio of 1:1 change to this value to 100% */
const useStyles = makeStyles(theme => ({
  root: {
    position: 'relative',
    backgroundColor: '#333',
    boxShadow: '0px 2px 1px -1px rgba(0,0,0,0.2),0px 1px 1px 0px rgba(0,0,0,0.14),0px 1px 3px 0px rgba(0,0,0,0.12)',
    '&:hover': {
      opacity: 1,
      transition: 'opacity 0.5s',
    },
  },
  inner: {
    position: 'absolute',
    top: 0,
    left: 0,
    width: '100%',
    height: '100%',
    overflow: 'hidden',
  },
  dark: {
    cursor: 'pointer',
    opacity: 0.7,
    transition: 'opacity 0.5s',
  },
}));

const AfficheImage = ({affiche = null, alt, ratio = 0.7, dark = false, onClick = undefined, width, height}) => {
  const classes = useStyles();
  const paddingBottom = `${(1 / ratio) * 100}%`;
  if (affiche) {
    let actualClasses = classes.root;
    if (dark) actualClasses += ' ' + classes.dark;

    const isAbsolute = affiche.includes('http');
    return (
      <div className={actualClasses} style={{paddingBottom}} onClick={onClick}>
        <div className={classes.inner}>
          <SizedImage
            src={isAbsolute ? affiche : `${Conf.assetsRoot}${affiche}`}
            fitRatio
            alt={alt}
            width={width}
            height={height}
          />
        </div>
      </div>
    );
  } else
    return (
      <div className={classes.root} style={{paddingBottom}} onClick={onClick}>
        <div className={classes.inner} />
      </div>
    );
};

export default AfficheImage;
